import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-28a7ea8e")

_pushScopeId("data-v-28a7ea8e")
const _hoisted_1 = { class: "ja-wrap" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "ja-header" }, [
  /*#__PURE__*/_createVNode("div", null, "分析模块")
], -1)
const _hoisted_3 = { class: "ja-body" }
const _hoisted_4 = { class: "ja-module" }
const _hoisted_5 = { class: "jam-edit" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "管理", -1)
const _hoisted_7 = { class: "ja-score" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "本模块总分：", -1)
const _hoisted_9 = { class: "ja-btn-group" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "sep" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "添加题目", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "删除", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, "移动", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "jm-header" }, [
  /*#__PURE__*/_createVNode("span", null, "添加字段")
], -1)
const _hoisted_17 = { class: "jm-body" }
const _hoisted_18 = { class: "jm-item" }
const _hoisted_19 = { class: "jm-footer" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { style: {"margin-left":"8px"} }, "添加新字段", -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "jm-header" }, [
  /*#__PURE__*/_createVNode("span", null, "移动至")
], -1)
const _hoisted_24 = { class: "jm-body" }
const _hoisted_25 = { class: "jm-item" }
const _hoisted_26 = { class: "jm-footer" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("确定")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FormOutlined = _resolveComponent("FormOutlined")
  const _component_a_button = _resolveComponent("a-button")
  const _component_draggableTable = _resolveComponent("draggableTable")
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")
  const _component_SwapOutlined = _resolveComponent("SwapOutlined")
  const _component_MenuOutlined = _resolveComponent("MenuOutlined")
  const _component_a_input = _resolveComponent("a-input")
  const _component_Draggable = _resolveComponent("Draggable")
  const _component_PlusCircleFilled = _resolveComponent("PlusCircleFilled")
  const _component_a_modal = _resolveComponent("a-modal")
  const _component_a_radio = _resolveComponent("a-radio")
  const _component_a_radio_group = _resolveComponent("a-radio-group")
  const _component_QuestionVue = _resolveComponent("QuestionVue")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.questionModules, (mo, moIndex) => {
          return (_openBlock(), _createBlock("div", {
            class: ["jam-btn", _ctx.currentModuleId===mo.uid?'jam-btn-active':''],
            key: mo.uid,
            onClick: ($event: any) => (_ctx.handleModuleBtnClick(mo))
          }, _toDisplayString(mo.moduleName), 11, ["onClick"]))
        }), 128)),
        _createVNode("div", _hoisted_5, [
          _createVNode("span", {
            class: "pointer",
            style: {"padding":"4px"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleModuleManageClick && _ctx.handleModuleManageClick(...args)))
          }, [
            _createVNode(_component_FormOutlined, { style: {"margin-right":"4px"} }),
            _hoisted_6
          ])
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode("span", null, _toDisplayString(_ctx.questionScore) + "分", 1)
      ]),
      _createVNode(_component_draggableTable, {
        class: "mb14",
        columns: _ctx.questionColumns,
        dataSource: _ctx.questionList,
        loading: _ctx.questionQuering||_ctx.questionDeleting,
        onEnd: _ctx.onTableDragEnd,
        onSelectChange: _ctx.onTableSelect
      }, {
        index: _withId(({record,index}) => [
          _createVNode("span", null, _toDisplayString(index + 1), 1)
        ]),
        questionType: _withId(({record}) => [
          _createVNode("span", null, _toDisplayString(_ctx.questionTypeFilter(record.questionType)), 1)
        ]),
        operation: _withId(({record}) => [
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_a_button, {
              type: "link",
              onClick: ($event: any) => (_ctx.handleEditQuestionClick(record))
            }, {
              default: _withId(() => [
                _hoisted_10
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _hoisted_11,
            _createVNode(_component_a_button, {
              type: "link",
              onClick: ($event: any) => (_ctx.handleDelQuestionClick(record))
            }, {
              default: _withId(() => [
                _hoisted_12
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["columns", "dataSource", "loading", "onEnd", "onSelectChange"]),
      _createVNode(_component_a_button, {
        class: "mr8",
        onClick: _ctx.handleAddQuestionClick,
        disabled: _ctx.questionList.length >= 20
      }, {
        default: _withId(() => [
          _createVNode(_component_PlusOutlined),
          _hoisted_13
        ]),
        _: 1
      }, 8, ["onClick", "disabled"]),
      _createVNode(_component_a_button, {
        class: "mr8",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDelQuestionClick(undefined))),
        disabled: _ctx.selectRowKeys.length <= 0
      }, {
        default: _withId(() => [
          _createVNode(_component_DeleteOutlined),
          _hoisted_14
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_a_button, {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modals.questionMove = true)),
        disabled: _ctx.selectRowKeys.length <= 0
      }, {
        default: _withId(() => [
          _createVNode(_component_SwapOutlined),
          _hoisted_15
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createVNode(_component_a_modal, {
      class: "jm-wrap",
      visible: _ctx.modals.modules,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (_ctx.modals.modules = $event)),
      width: 416
    }, {
      title: _withId(() => [
        _hoisted_16
      ]),
      footer: _withId(() => [
        _createVNode("div", _hoisted_19, [
          _createVNode("span", {
            class: "btn fl",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.questionModulesClone.length >= 8 ? '' : _ctx.handleAddModuleClick(false))),
            style: {color: (_ctx.questionModulesClone.length >= 8 ? "#ccc" : "")}
          }, [
            _createVNode(_component_PlusCircleFilled, { style: {"font-size":"18px"} }),
            _hoisted_20
          ], 4),
          _createVNode(_component_a_button, {
            type: 'default',
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.modals.modules = false)),
            disabled: _ctx.loadings.modulesSaving
          }, {
            default: _withId(() => [
              _hoisted_21
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.handleSaveModulesClick,
            loading: _ctx.loadings.modulesSaving,
            disabled: _ctx.questionModulesClone.length > 8
          }, {
            default: _withId(() => [
              _hoisted_22
            ]),
            _: 1
          }, 8, ["onClick", "loading", "disabled"])
        ])
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_17, [
          _createVNode(_component_Draggable, _mergeProps(_ctx.dragOption, {
            modelValue: _ctx.questionModulesClone,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.questionModulesClone = $event)),
            onEnd: _ctx.onModuleDragEnd,
            "item-key": "uid"
          }), {
            item: _withId(({ element,index }) => [
              _createVNode("div", _hoisted_18, [
                _createVNode(_component_MenuOutlined),
                _createVNode(_component_a_input, {
                  value: element.moduleName,
                  "onUpdate:value": ($event: any) => (element.moduleName = $event),
                  placeholder: "请输入10字以内信息",
                  maxlength: 10
                }, null, 8, ["value", "onUpdate:value"]),
                (_ctx.questionModulesClone.length > 1)
                  ? (_openBlock(), _createBlock("span", {
                      key: 0,
                      class: "btn btn-gray",
                      onClick: ($event: any) => (_ctx.handleDelModuleClick(index,element))
                    }, "删除", 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 16, ["modelValue", "onEnd"])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      class: "jm-wrap",
      visible: _ctx.modals.questionMove,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => (_ctx.modals.questionMove = $event)),
      width: 416
    }, {
      title: _withId(() => [
        _hoisted_23
      ]),
      footer: _withId(() => [
        _createVNode("div", _hoisted_26, [
          _createVNode(_component_a_button, {
            type: 'default',
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.modals.questionMove = false)),
            disabled: _ctx.loadings.moveLoding
          }, {
            default: _withId(() => [
              _hoisted_27
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.handleMoveModulesClick,
            loading: _ctx.loadings.moveLoding
          }, {
            default: _withId(() => [
              _hoisted_28
            ]),
            _: 1
          }, 8, ["onClick", "loading"])
        ])
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_24, [
          _createVNode(_component_a_radio_group, {
            value: _ctx.moveModule,
            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.moveModule = $event))
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.questionModules, (element, index) => {
                return (_openBlock(), _createBlock("div", _hoisted_25, [
                  _createVNode(_component_a_radio, { value: index }, null, 8, ["value"]),
                  _createVNode(_component_a_input, {
                    value: element.moduleName,
                    "onUpdate:value": ($event: any) => (element.moduleName = $event),
                    placeholder: "请输入10字以内信息",
                    maxlength: 10,
                    disabled: true
                  }, null, 8, ["value", "onUpdate:value"])
                ]))
              }), 256))
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_QuestionVue, {
      visible: _ctx.modals.addQuestion,
      onOk: _ctx.handleQuestionOk,
      onCancel: _cache[11] || (_cache[11] = ($event: any) => (_ctx.modals.addQuestion = false)),
      data: _ctx.currentQuestionData
    }, null, 8, ["visible", "onOk", "data"])
  ]))
})